import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { DrawerBody, DrawerFooter, Button } from '@one-thd/sui-atomic-components';
import { RatingsAndReviewsCondensed } from '@thd-olt-component-react/ratings-and-reviews';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';
import { useIntentProductData } from '../../hooks/useIntentProductData';

export const ProductReviews = ({
  itemId, isDisplayOnly, onSubmit
}) => {
  const { addToType } = useContext(AddToContext);

  const handleSubmit = async () => {
    onSubmit(SCREENS.MINI_PIP_PRODUCT_REVIEWS);
  };

  return (
    <>
      <DrawerBody data-testid="test-productreviews">
        <RatingsAndReviewsCondensed itemId={itemId} />
      </DrawerBody>
      <DrawerFooter position="center">
        {!isDisplayOnly && (
          <Button
            data-testid="productReviews-AITP-button"
            variant="secondary"
            fullWidth
            onClick={handleSubmit}
            type="submit"
          >
            Add to {addToType}
          </Button>
        )}
      </DrawerFooter>
    </>
  );
};

ProductReviews.displayName = 'ProductReviews';

ProductReviews.propTypes = {
  itemId: PropTypes.string.isRequired,
  isDisplayOnly: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

ProductReviews.defaultProps = {
  isDisplayOnly: false
};

ProductReviews.dataModel = extend(RatingsAndReviewsCondensed, useIntentProductData);
